import { createBrowserRouter, RouterProvider, Navigate, Outlet } from 'react-router-dom';
import { MantineProvider, Center, Loader } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Layout } from './components/Layout';
import { Map } from './pages/Map';
import { Personas } from './pages/Personas';
import { PersonaDetail } from './pages/PersonaDetail';
import { Detections } from './pages/Detections';
import { Devices } from './pages/Devices';
import { Terms } from './pages/Terms';
import Login from './pages/Login';
import { theme } from './theme';

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';

function ProtectedRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <Map />,
      },
      {
        path: 'personas',
        element: <Personas />,
      },
      {
        path: 'personas/:id',
        element: <PersonaDetail />,
      },
      {
        path: 'detections',
        element: <Detections />,
      },
      {
        path: 'devices',
        element: <Devices />,
      },
    ],
  },
]);

export function App() {
  return (
    <MantineProvider theme={theme}>
      <Notifications position="top-left" />
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </MantineProvider>
  );
}
